export default ({
  value,
  decimalCount
}) => Math.round((value + Number.EPSILON) * Math.pow(10, decimalCount)) / Math.pow(10, decimalCount)
